import * as React from 'react';
import * as Styled from './input-bar.styles';
export const InputBar = ({ className, clearButtonProps, disabled, icon: Icon, innerRef, multiline = false, onChange, onClearInput, placeholder, size = 'medium', sizeConfined, sizeWide, value, variant = 'default', ...props }) => {
    const [showClearButton, setShowClearButton] = React.useState(false);
    const handleReset = (e) => {
        // @ts-ignore
        onChange && onChange({ target: { value: '' } });
        onClearInput && onClearInput(e);
    };
    const handleChange = (e) => {
        onChange && onChange(e);
    };
    React.useEffect(() => {
        setShowClearButton(value.length > 0);
    }, [value]);
    const isFilled = value.length > 0;
    const iconSize = size === 'small' ? 18 : 24;
    const commonProps = {
        $isFilled: isFilled,
        $size: size,
        $sizeConfined: sizeConfined,
        $sizeWide: sizeWide,
        $variant: variant,
        'data-xds': 'InputBar',
        disabled: disabled,
        placeholder: placeholder,
        ref: innerRef,
        value: value,
    };
    return (React.createElement(Styled.Wrapper, { className: className },
        multiline ? (React.createElement(Styled.Textarea, { onChange: onChange, ...commonProps, ...props })) : (React.createElement(Styled.Input, { "$iconSize": iconSize, "$isIconSet": Boolean(Icon), "$showClearButton": showClearButton, onChange: handleChange, ...commonProps, ...props })),
        Icon && !multiline && (React.createElement(Styled.IconContainer, { "$iconSize": iconSize, "$size": size, "$sizeConfined": sizeConfined, "$sizeWide": sizeWide, "$variant": variant },
            React.createElement(Icon, { width: iconSize, height: iconSize }))),
        showClearButton && !multiline && (React.createElement(Styled.ClearButton, { "$variant": variant, disabled: disabled, onClick: (e) => handleReset(e), type: "reset", ...clearButtonProps },
            React.createElement(Styled.Cross, { "aria-hidden": "true", height: iconSize, width: iconSize })))));
};
//# sourceMappingURL=input-bar.js.map